<template>
    <div class="address-book">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="addressBook"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
                align="left"
            >
                <el-table-column
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column label="Name">
                    <template slot-scope="scope">
                        <div class="name">
                            <!-- <i
                                class="el-icon-circle-check"
                                v-if="scope.row.default"
                            ></i
                            > -->{{ scope.row.name }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Street Address"
                    min-width="150"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div class="ellipsis">
                            {{ scope.row.street1 + scope.row.street2 }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="City" prop="city"></el-table-column>
                <el-table-column
                    label="Country"
                    prop="country_name"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column label="State" prop="state"></el-table-column>
                <el-table-column
                    label="Phone"
                    prop="phone"
                    width="150"
                ></el-table-column>
                <el-table-column
                    label="Postal Code"
                    prop="postal_code"
                    width="120"
                ></el-table-column>
                <el-table-column align="center" label="Default" prop="default" width="120">
                    <template slot-scope="scope">
                        <span
                            :class="[
                                scope.row.default == 1
                                    ? 'general-table-tag success'
                                    : '',
                            ]"
                            v-if="scope.row.default == 1"
                        >
                            <i class="el-icon-s-help"></i>
                            Default
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Operation" width="150">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <add :addVisible.sync="addVisible" :funcName="funcName"></add>
        <edit
            :editVisible.sync="editVisible"
            :funcName="funcName"
            :tableItem.sync="tableItem"
        ></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></detail>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import detail from "./addressBook/detail.vue";
import add from "@/views/pages/shipping/shippingAdmin/add.vue";
import edit from "@/views/pages/shipping/shippingAdmin/edit.vue";
import remarkPopTable from "@/common/components/table/remarkPopTable";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Name、Street Address、City、Country、State、Phone、PostalCode",
            searchForm: {},
            searchForm_transfer: {},
            funcName: "addressBook",
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            selectList: [],
            platform_id: "",
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
            },
        };
    },
    methods: {
        add() {
            this.addVisible = true;
        },
        addressBook(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .addressBook(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "detail") {
                    this.detailVisible = true;
                } else if (item.funcName == "edit") {
                    this.editVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.addressBook();
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        detail,
        add,
        edit,
        remarkPopTable,
    },
    computed: {},
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (
                        v instanceof Array
                            ? !!v.join("")
                            : !!v && k !== "status"
                    ) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.address-book {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
